import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

export function useActionNotificationStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = useTheme();
  const actionHeaderStyle = {
    color: colorStyle.color.secondary,
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '600',
  };
  const iconColor = colorStyle.color.secondary;
  const checkboxColor = colorStyle.color.secondary;
  return { actionHeaderStyle, checkboxColor, iconColor };
}

export function useRulesStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = useTheme();
  const iconColor = colorStyle.color.secondary;
  const checkboxColor = colorStyle.color.secondary;
  return { checkboxColor, iconColor };
}
